<template>
  <div>
    <info-list
      :form-model="formModel"
      :headers="formFields"
    ></info-list>
  </div>
</template>

<script>
import { debtorAssetTypeEnum } from '@/modules/bankruptcy/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
import InfoList from '@/modules/bankruptcy/components/bankruptcy-file/info-list.vue';
import { toHijriDate } from '@/helpers/utils';
const { mapState, mapActions } = createNamespacedHelpers('BankruptcyModule');

export default {
  components: { InfoList },
  props: {
    formModel: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    viewMode: {
      type: Boolean,
      required: true,
      default: () => false,
    },

  },
  data() {
    return {
      locale: this.local.bankruptcy.requestDetails,
      toHijriDate,
    };
  },
  computed: {
    ...mapState(['assetTypes', 'realEstateTypes']),
    formFields() {
      return {
        [`asset_${debtorAssetTypeEnum.bankAccount}`]: this.bankAccountFormFields,
        [`asset_${debtorAssetTypeEnum.investmentPortfolio}`]: this.investmentPortfolioFormFields,
        [`asset_${debtorAssetTypeEnum.realEstate}`]: this.realEstateFormFields,
        [`asset_${debtorAssetTypeEnum.vehicle}`]: this.vehicleFormFields,
        [`asset_${debtorAssetTypeEnum.transported}`]: this.transportedFormFields,
        [`asset_${debtorAssetTypeEnum.other}`]: this.otherFormFields,
        [`asset_undefined`]: [],
        [`asset_null`]: [],
      }[`asset_${this.formModel.assetTypeId}`];
    },
    bankAccountFormFields() {
      return [
        {
          key: 'assetName',
          text: this.locale.debtorAssets.bankName,
        },
        {
          key: 'assetNumber',
          text: this.locale.debtorAssets.iBAN,
        },
        {
          key: 'assetValue',
          text: this.locale.debtorAssets.assetValue,
        },
      ];
    },
    investmentPortfolioFormFields() {
      return [
        {
          key: 'assetNumber',
          text: this.locale.debtorAssets.portfolioNumber,
        },
        {
          key: 'assetName',
          text: this.locale.debtorAssets.organizationName,
        },
        {
          key: 'assetValue',
          text: this.locale.debtorAssets.assetValue,
        },
      ];
    },
    realEstateFormFields() {
      return [
        {
          key: 'realEstateTypeId',
          text: this.locale.debtorAssets.realEstateType,
        },
        {
          key: 'assetName',
          text: this.locale.debtorAssets.otherRealEstateType,
        },
        {
          key: 'judgementCode',
          text: this.locale.debtorAssets.judgementCode,
        },
        {
          key: 'judgementDate',
          text: this.locale.debtorAssets.judgementDate,
          formatter: toHijriDate,
        },
        {
          key: 'assetValue',
          text: this.locale.debtorAssets.assetValue,
        },
        {
          key: 'assetLocation',
          text: this.locale.debtorAssets.assetLocation,
        },
      ];
    },
    vehicleFormFields() {
      return [
        {
          key: 'assetName',
          text: this.locale.debtorAssets.vehicleType,
        },
        {
          key: 'assetNumber',
          text: this.locale.debtorAssets.purchaseYear,
        },
        {
          key: 'assetValue',
          text: this.locale.debtorAssets.assetValue,
        },
      ];
    },
    transportedFormFields() {
      return [
        {
          key: 'assetName',
          text: this.locale.debtorAssets.transportedType,
        },
        {
          key: 'assetNumber',
          text: this.locale.debtorAssets.purchaseYear,
        },
        {
          key: 'assetValue',
          text: this.locale.debtorAssets.assetValue,
        },
      ];
    },
    otherFormFields() {
      return [
        {
          key: 'assetName',
          text: this.locale.debtorAssets.assetType,
        },
        {
          key: 'assetValue',
          text: this.locale.debtorAssets.assetValue,
        },
      ];
    },
  },

  methods: {
    ...mapActions(['getAssetTypes', 'getRealEstateTypes']),
    assetTypeChanged() {
      for (const key in this.formModel) {
        if (Object.hasOwnProperty.call(this.formModel, key) && key !== 'assetTypeId' && key !== 'objectKey')
          this.$set(this.formModel, key, undefined);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
